import { Card, CardContent } from "@/components/ui/card";

export function StatCard({ label, value, hint, testid }) {
  return (
    <Card className="border-border shadow-none rounded-lg hover:-translate-y-0.5 transition-transform" data-testid={testid}>
      <CardContent className="p-6">
        <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground">{label}</p>
        <p className="font-display text-3xl font-extrabold tracking-tighter mt-2">{value}</p>
        {hint ? <p className="text-xs text-muted-foreground mt-1">{hint}</p> : null}
      </CardContent>
    </Card>
  );
}

/**
 * StreakCard — a dressed-up StatCard for habit streaks. Shows the current
 * daily streak large, with a secondary line for the weekly journal streak
 * or best-ever streak. Pops with the brass-gold accent when active.
 */
export function StreakCard({ streaks, testid = "streak-card" }) {
  const daily = streaks?.daily_streak || 0;
  const weekly = streaks?.weekly_journal_streak || 0;
  const best = streaks?.best_daily_streak || 0;
  const monthPrompts = streaks?.month_prompts_total || 0;
  const hasStreak = daily >= 2 || weekly >= 2;

  let hint = "Log a journal entry or complete a prompt today to start a streak.";
  if (hasStreak) {
    const parts = [];
    if (weekly >= 2) parts.push(`${weekly}-week journaling`);
    if (best > daily) parts.push(`best ever ${best} days`);
    if (monthPrompts >= 1) parts.push(`${monthPrompts} prompts this month`);
    hint = parts.join(" · ");
  } else if (daily === 1) {
    hint = "1 day in — keep it going tomorrow!";
  }

  return (
    <Card
      className={`border-border shadow-none rounded-lg hover:-translate-y-0.5 transition-transform ${hasStreak ? "bg-secondary border-secondary" : ""}`}
      data-testid={testid}
    >
      <CardContent className="p-6">
        <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Streak</p>
        <p
          className={`font-display text-3xl font-extrabold tracking-tighter mt-2 ${hasStreak ? "text-primary" : ""}`}
          data-testid={`${testid}-value`}
        >
          {hasStreak || daily === 1 ? (
            <>
              <span aria-hidden="true">🔥</span>{" "}
              <span data-testid={`${testid}-days`}>{daily}d</span>
            </>
          ) : (
            "—"
          )}
        </p>
        <p className="text-xs text-muted-foreground mt-1" data-testid={`${testid}-hint`}>{hint}</p>
      </CardContent>
    </Card>
  );
}

export function SectionTitle({ overline, title, action }) {
  return (
    <div className="flex items-end justify-between mb-6">
      <div>
        {overline ? (
          <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-1.5">{overline}</p>
        ) : null}
        <h2 className="font-display text-2xl sm:text-3xl font-extrabold tracking-tighter">{title}</h2>
      </div>
      {action}
    </div>
  );
}
